import { Grid, Typography } from '@material-ui/core';
import { TrackingContext } from 'components/providers/tracking';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import urlNormalizer from 'tools/urlNormalization';
import Image from "next/image";
import { getProductPrices } from "../../../../functions/productOps";
import { elevateClickNotification } from "tools/elevateClient";
import useSessionStore from '@services/stores/SessionStore';

export default function SearchResultContentItem({ props }) {
    const { item, classes, source, config, isMobile} = props;
	const { actions } = useContext(TrackingContext);
	const router = useRouter();

	async function onProductClick() {
			actions.click({
				type: 'content_search',
				text: item.title,
			});

			await elevateClickNotification(
				item.ticket,
				isMobile ? 'mobile' : 'desktop'
			);
	}

	function getItemImage() {
        const imageSource = item?.image?.sources?.[0]
        const width = (imageSource.width || 550);
        const height = (imageSource.height || 510);
        return {
            src: imageSource?.url || '',
            layout: 'fill',
            objectFit: 'cover'
        }
	}

	function getItemUrl() {
		return item.link;
	}

	function getItemName() {
		return item.title;
	}

    function getItemType() {
		return item.type;
	}


    function renderItem() {
        if (source === 'dropdown') {
           return <Grid xs={12} sm={12} md={6} key={`search-results-${item.key}`} item>
                    <Link href={urlNormalizer(getItemUrl(), router.basePath)}>
                        <a className={[classes.product, focus ? 'focus' : ''].join(' ')} onClick={onProductClick}>

                            <div className={[classes.product__image, 'inspiration'].join(' ')}>
                                <Image {...getItemImage()} unoptimized/>
                            </div>
                            <div className={[classes.product__info, 'inspiration'].join(' ')}>
                                <Typography
                                    className={classes.product__name}
                                    variant="body1"
                                    dangerouslySetInnerHTML={{ __html: getItemName() }}
                                />

                                <Typography
                                    className={classes.product__type}
                                    variant="body1"
                                    dangerouslySetInnerHTML={{ __html: getItemType() }}
                                />
                            </div>
                        </a>
                    </Link>
                </Grid>
        }
        if (source === 'page') {
            return <Grid xs={12} sm={6} md={4} lg={4} key={`search-results-${item.key}`} item>
                <Link href={urlNormalizer(getItemUrl(), router.basePath)}>
                    <a className={[classes.product, focus ? 'focus' : ''].join(' ')} onClick={onProductClick}>

                        <div className={[classes.product__image, 'inspiration'].join(' ')}>
                            <Image {...getItemImage()} unoptimized/>
                        </div>
                        <div className={[classes.product__info, 'inspiration'].join(' ')}>
                            <Typography
                                className={classes.product__name}
                                variant="body1"
                                dangerouslySetInnerHTML={{ __html: getItemName() }}
                            />
                        </div>
                    </a>
                </Link>
            </Grid>
        }
        return <></>
    }


	return renderItem();
}
